import { render, staticRenderFns } from "./PokemonBattle.vue?vue&type=template&id=3622fc1c&scoped=true&"
import script from "./PokemonBattle.vue?vue&type=script&lang=js&"
export * from "./PokemonBattle.vue?vue&type=script&lang=js&"
import style0 from "./PokemonBattle.vue?vue&type=style&index=0&id=3622fc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622fc1c",
  null
  
)

export default component.exports